import { Card, Row, Col, Button } from '@themesberg/react-bootstrap'
import React, { useState } from 'react'
import { ExclamationCircleOutlined, InboxOutlined } from '@ant-design/icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSetRecoilState } from 'recoil';
import { Form, Input, Upload, Button as AntButton, Modal, Select, Tooltip, Space } from 'antd';
import { dummyRequest, getHtml, getRawData } from '../../../services/utilities';
import { activatePos, deletePos, updatePos } from '../../../services/apiCalls';
import { faEdit, faExclamation, faTrash } from '@fortawesome/free-solid-svg-icons';
import { featureAlert, featureResponse, posRefresh } from '../../../states/wayaPos';
import { EditorState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';

const GramCard = ({ img, description, status, type, name, position, google_url, app_url, get_start_url, link_url, title, ben, id, uploadImage }) => {
  const [loading, setLoading] = useState(false)
  const [file, setFile] = useState()
  const [createModal, setCreateModal] = useState(false)
  const setShowAlert = useSetRecoilState(featureAlert);
  const setResponse = useSetRecoilState(featureResponse)
  const [editor, setEditor] = useState("")
  const [editorDesc, setEditorDesc] = useState("")
  const setRefresh = useSetRecoilState(posRefresh)
  const [form] = Form.useForm()
  const { confirm } = Modal;
  
  const onFinish = async (val) => {
    setLoading(true)
    const date = new Date()
    const fd = new FormData();
    // fd.append('title', val.title)
    // fd.append('description', val.description)
    // fd.append('link_url', val.linkUrl)
    fd.append('title', getHtml(editor))
    fd.append('description', getHtml(editorDesc))
    fd.append('position', val.position)
    fd.append('google_url', val.google_url)
    fd.append('app_store_url', val.app_store_url)
    fd.append('get_start_url', val.get_start_url)
    fd.append('file', file);
    try {
      const res = await updatePos({ data: fd, id })
      if (res.status) {
        setResponse({ message: res.message, title: "success" })
        setShowAlert(true)
        setRefresh(date.toTimeString())
        setCreateModal(false)
        setFile('')
      } else {
        setResponse({ message: res.message || res, title: "failed" })
        setShowAlert(true)
        setFile()
      }
    } catch (error) {
      console.log(error)
    }
    setLoading(false)
    setFile()
  }

  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  const handleChange = info => {
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, imageUrl => {
        setFile(info.file.originFileObj)
      });
    }
  };
  const onEditorStateChange = editorState => {
    setEditor(editorState);
  };
  const onEditorStateChanges = editorState => {
    setEditorDesc(editorState);
  };
  const handleUpdate = () => {
    setCreateModal(true)
      if (title) {
        const contentState = getRawData(title)
        setEditor(EditorState.createWithContent(contentState));
      }
      if (description) {
        const contentStateDesc = getRawData(description)
        setEditorDesc(EditorState.createWithContent(contentStateDesc));
      }
    // setValue(val)
  }

  const offVul = (id) => {
    const data = {status: 0}
    console.log(id)
    confirm({
      title: `Are you sure you want to activate ${name}?`,
      icon: <FontAwesomeIcon icon={faExclamation} color="primary" />,
      content: 'Click Ok to continue',
      onOk() {
        handleShowHide(id, data)
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const onVul = (id) => {
    const data = {status: 1}
    console.log(id)
    confirm({
      title: `Are you sure you want to activate ${name}?`,
      icon: <FontAwesomeIcon icon={faExclamation} color="primary" />,
      content: 'Click Ok to continue',
      onOk() {
        handleShowHide(id, data)
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const handleShowHide = async (id, status) => {
    const date = new Date()
    console.log(id)
    console.log(status)
    const res = await activatePos({ data: status, id })
    if (res.status) {
      setResponse({ message: res.message, title: "success" })
      setShowAlert(true)
      setRefresh(date.toTimeString())
    } else {
      setResponse({ message: res.message || res, title: "failed" })
      setShowAlert(true)
    }
  }

  const confirmDelete = (id) => {
    confirm({
      title: `Are you sure you want to delete this Post?`,
      icon: <ExclamationCircleOutlined />,
      content: 'Click Ok to continue',
      onOk() {
        handleDelete(id)
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const handleDelete = async (id) => {
    const date = new Date()
    const res = await deletePos(id)
    if (res.status) {
      setResponse({ message: res.message, title: "success" })
      setShowAlert(true)
      setRefresh(date.toTimeString())
    } else {
      setResponse({ message: res.message || res, title: "failed" })
      setShowAlert(true)
    }
  }

  return (
    <>
      <Card border="light" className="bg-white shadow-sm mb-4">
        <Card.Body>
          {type === "POS" ?
            <Row>
              <Col xs={12} md={6} xl={6} lg={6}>
                <img src={img} width='250' alt="hero POS" />
              </Col>
              <Col xs={12} md={6} xl={6} lg={6}>
                <p dangerouslySetInnerHTML={{ __html: title }} />
                <p dangerouslySetInnerHTML={{ __html: description === 'undefined' ? '' : description}} />
                <Space size="small">
                  <Tooltip title='Edit'>
                    <AntButton type="ghost" onClick={() => handleUpdate()}>
                      <FontAwesomeIcon icon={faEdit} />
                    </AntButton>
                  </Tooltip>
                  <Tooltip title='Delete'>
                    <AntButton type="danger" onClick={() => confirmDelete(id)}>
                      <FontAwesomeIcon icon={faTrash} />
                    </AntButton>
                  </Tooltip>
                  {status === 1 ?
                    <Tooltip title='Deactivate'>
                      <AntButton type="danger" onClick={()=>offVul(id)}>
                        Deactivate
                      </AntButton>
                    </Tooltip>:
                    <Tooltip title='Activate'>
                      <AntButton type="primary" onClick={()=>onVul(id)}>
                        Activate
                      </AntButton>
                    </Tooltip>
                  }
                </Space>
              </Col>
            </Row> :
            <div>
              <img src={img} width={200} alt="hero pos" />
                <p dangerouslySetInnerHTML={{ __html: title }} />
                <p dangerouslySetInnerHTML={{ __html: description === 'undefined' ? '' : description}} />
              <Space size="small">
                <Tooltip title='Edit'>
                  <AntButton type="ghost" onClick={() => handleUpdate()}>
                    <FontAwesomeIcon icon={faEdit} />
                  </AntButton>
                </Tooltip>
                <Tooltip title='Delete'>
                  <AntButton type="danger" onClick={() => confirmDelete(id)}>
                    <FontAwesomeIcon icon={faTrash} />
                  </AntButton>
                </Tooltip>
                {status === 1 ?
                  <Tooltip title='Deactivate'>
                    <AntButton type="danger" onClick={()=>offVul(id)}>
                      Deactivate
                    </AntButton>
                  </Tooltip>:
                  <Tooltip title='Activate'>
                    <AntButton type="primary" onClick={()=>onVul(id)}>
                      Activate
                    </AntButton>
                  </Tooltip>
                }
              </Space>
            </div>
          }
        </Card.Body>
      </Card>

      <Modal
        title="Update Waya POS"
        centered
        visible={createModal}
        footer={null}
        onCancel={() => setCreateModal(false)}
      >
        <Form form={form} onFinish={onFinish} layout="vertical" initialValues={{ title, position, google_url, app_url, get_start_url, link_url, description, image_url: img }}>
         <Form.Item label="Title" name="title" rules={[{ required: true }]}>
            {/* <Input /> */}
            <Editor
              editorState={editor}
              editorClassName="px-3 border border-gray-1"
              editorStyle={{
                height: 50,
                overflow: 'auto',
              }}
              onEditorStateChange={onEditorStateChange}
            />
          </Form.Item>
          {/* {type === 'POS' &&
            <> */}
              <Form.Item label="Description" name="description">
                {/* <Input.TextArea /> */}
                <Editor
                  editorState={editorDesc}
                  editorClassName="px-3 border border-gray-1"
                  editorStyle={{
                    height: 100,
                    overflow: 'auto',
                  }}
              onEditorStateChange={onEditorStateChanges}
            />
              </Form.Item>
            <Form.Item label="Position" name="position">
              <Input type='number' />
            </Form.Item>
            <Form.Item label="Google Play Link" name="google_url">
              <Input />
            </Form.Item>
            <Form.Item label="App Store Link" name="app_url">
              <Input />
            </Form.Item>
            <Form.Item label="Get Started Link" name="get_start_url">
              <Input />
            </Form.Item>
              <Form.Item >
                <Upload onChange={handleChange} customRequest={dummyRequest} maxCount={1}>
                  <AntButton icon={<InboxOutlined />}>Upload Feature Image</AntButton>
                </Upload>
              </Form.Item>
            {/* </>
          } */}
          <Form.Item>
            <AntButton type="primary" htmlType="submit" loading={loading}>
              Update
            </AntButton>
          </Form.Item>
        </Form>
      </Modal>
    </>
  )
}

export default GramCard
